/**
 * Profile and homepage copy with legacy backup.
 * Set USE_LEGACY_COPY to true to restore the previous text sitewide.
 */

/** Set to true to restore pre-Option C copy across profile and homepage. */
export const USE_LEGACY_COPY = false;

export interface ProfileSeoCopy {
  profileTitle: string;
  profileDescription: string;
  homeTitle: string;
  homeDescription: string;
  personDescription: string;
  serviceDescription: string;
  websiteName: string;
  websiteDescription: string;
  jobTitle: string;
}

export interface ProfileTextCopy {
  intro: string;
  /** Styled hero headline on profile page. Falls back to intro when omitted. */
  headline?: string;
  subtitle: string;
  bio: string;
  seo: ProfileSeoCopy;
}

const LEGACY_HOME_INTRO =
  'Creative Director and Designer focused on building brands that move people and business. Two decades building and leading global teams from concept to launch, strategy to story. Exploring how AI can amplify creativity, not replace it.';

const OPTION_C_HOME_INTRO =
  'I am a creative leader and builder. I orchestrate AI across brands, teams and products for clients including Mack, Volvo, IKEA, H&M, Nike and Formula 1.';

export const LEGACY_PROFILE_TEXT: ProfileTextCopy = {
  intro: 'Besart Bujupi',
  subtitle: 'Creative leader & Designer',
  bio: `I'm Bes, a Creative Director with over 20 years of experience building brands, teams, and ideas that drive business results. I blend strategy, design, and storytelling to create resonant, high-impact experiences.

 Brand Building: 
Defining how a brand looks, feels, and speaks—clear, consistent, unmistakable.

Product Design: 
Crafting intuitive, user-focused experiences balancing simplicity and delight.

Business Impact: 
Turning creative vision into measurable engagement and brand equity.

Technology: 
Leading teams in 3D, immersive, and AR/VR content for innovative brand ecosystems.

Scalable Systems: 
Building design systems for consistent quality across markets.

Leadership: 
Empowering cross-functional teams to deliver exceptional work at speed.

I deliver creativity that captures attention, builds loyalty, and fuels growth at the intersection of design, technology, and business.

`,
  seo: {
    profileTitle: 'Bes Bujupi – Designer & Creative Leader.',
    profileDescription:
      'Learn more about Bes Bujupi, a designer and creative leader specializing in innovative digital experiences and creative direction.',
    homeTitle: 'Bes Bujupi – Designer & Creative Leader',
    homeDescription:
      'Creative Director & design leader Bes Bujupi. Brand building, product design, 3D/AR experiences. Clients: Volvo, Nike, Formula 1, Nissan. 20+ years. Gothenburg.',
    personDescription:
      'Creative Director with 20+ years building brands, teams, and digital experiences. Brand building, product design, 3D/AR/VR, design systems. Clients include Volvo, Nike, Formula 1, Nissan.',
    serviceDescription:
      'Brand building, product design, 3D/AR experiences, design systems. 20+ years with Volvo, Nike, Formula 1, Nissan.',
    websiteName: 'Bes Bujupi – Designer & Creative Leader',
    websiteDescription: 'Portfolio of Creative Director Bes Bujupi. Brand building, product design, 3D/AR experiences.',
    jobTitle: 'Creative Director',
  },
};

export const OPTION_C_PROFILE_TEXT: ProfileTextCopy = {
  intro: 'Bes.art',
  headline: 'Bes.art',
  subtitle: 'Creative leader and builder / orchestrator across brands, teams and products.',
  bio: `I build exceptional brands, teams, products and digital experiences. I orchestrate AI across the full creative stack, from strategy and story through to 3D, AR and systems that scale.

Notable clients include Volvo, Nike, Formula 1, Nissan, Polestar, Zeekr, Mack Trucks, Nivea and H&M.

I am a senior creative partner to executive stakeholders, founders, and brand, product and marketing leaders.

My career includes serving as Executive Creative Director at Rapid in Gothenburg and seven years as Creative Director at AKQA across London, Gothenburg, and Stockholm. Throughout that time, I led multidisciplinary teams spanning design, strategy, production, and engineering, helping global brands launch products, build stronger customer experiences, and drive measurable business growth.

The results have been brand systems and digital experiences that work at scale: configurators, launches, immersive content and design systems with measurable impact. I have received industry recognition including FWA Site of the Day, Awwwards, Webby Honoree and IAB Creative Showcase.

I believe great creative, strong relationships and solid execution go a long way.
`,
  seo: {
    profileTitle: 'Bes Bujupi – Creative Leader & Builder',
    profileDescription:
      'Bes Bujupi is a creative leader and builder who orchestrates AI across brands, teams and products. Executive Creative Director at Rapid. Clients include Volvo, Nike and Formula 1.',
    homeTitle: 'Bes Bujupi – Creative Leader & Builder',
    homeDescription:
      'Creative leader and builder. Bes Bujupi orchestrates AI across brands, teams and products. Clients: Volvo, Nike, Formula 1, Nissan. Executive Creative Director, Rapid, Gothenburg.',
    personDescription:
      'Creative leader and builder who orchestrates AI across brands, teams and products. Executive Creative Director at Rapid. Brand building, product design, 3D/AR, design systems. Clients include Volvo, Nike, Formula 1, Nissan.',
    serviceDescription:
      'Creative leadership and AI orchestration across brands, teams and products. Brand building, product design, 3D/AR experiences, design systems. Volvo, Nike, Formula 1, Nissan.',
    websiteName: 'Bes Bujupi – Creative Leader & Builder',
    websiteDescription:
      'Portfolio of creative leader Bes Bujupi. Orchestrating AI across brands, teams and immersive digital experiences.',
    jobTitle: 'Executive Creative Director',
  },
};

export const PROFILE_TEXT = USE_LEGACY_COPY ? LEGACY_PROFILE_TEXT : OPTION_C_PROFILE_TEXT;
export const HOME_INTRO = USE_LEGACY_COPY ? LEGACY_HOME_INTRO : OPTION_C_HOME_INTRO;
export const PROFILE_STORAGE_KEY = USE_LEGACY_COPY ? 'profile_content' : 'profile_content_v4';
export const HOME_STORAGE_KEY = USE_LEGACY_COPY ? 'home_intro' : 'home_intro_v3';
